import { useEffect, useState } from 'react'
import React from 'react'
import { Container, Card, Row, Col, Button, Modal, Form, FormGroup, FormLabel, FormSelect } from 'react-bootstrap'
import { 
  FaArrowLeft, 
  FaEye, 
  FaUser, 
  FaPhone, 
  FaEnvelope, 
  FaMapMarkerAlt,
  FaIdCard,
  FaUsers,
  FaShieldAlt,
  FaWallet,
  FaCalendarCheck,
  FaGraduationCap,
  FaPrint,
  FaWhatsapp,
  FaVenusMars
} from 'react-icons/fa'
import { 
  BsPrinterFill,
  BsPencilFill,
  BsBuilding,
  BsCalendar3,
  BsPersonBadge,
  BsFileEarmarkText,
  BsArrowClockwise,
  BsChevronDown,
  BsChevronUp,
  BsFileEarmarkPdfFill
} from 'react-icons/bs'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import toast from 'react-hot-toast'
import axios from 'axios'
import { useSidebar } from './SidebarContext'
import { useAuth } from './AuthContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'
import { LuGraduationCap } from 'react-icons/lu'
import jsPDF from 'jspdf'

const DischargedStudentsProfile = ({ student }) => {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id: instituteId } = useInstitute();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const { id } = useParams()
  console.log('id:', id)
  const [data, setData] = useState('')
  console.log('data is define here', data)
  const navigate = useNavigate()

  const [studentData, setStudentData] = useState(null)
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [institutes, setInstitutes] = useState([])
  const [parentEmail, setParentEmail]=useState("")
  const [opentDateModal, setOpenDateModal] = useState(false)
  const [highlightUpdate, setHighlightUpdate] = useState(false)
  const [leavingDate, setLeavingDate] = useState('')
  const [guardians, setGuardians] = useState([])
  const [loadingGuardians, setLoadingGuardians] = useState(false)
  
  // Section visibility states - only Personal Information open initially
  const [showPersonalInfo, setShowPersonalInfo] = useState(true)
  const [showParentInfo, setShowParentInfo] = useState(true)
  const [showAssignGuardian, setShowAssignGuardian] = useState(true)
  const [showStudentActions, setShowStudentActions] = useState(true)

  useEffect(() => {
    const storedInstitute = Cookies.get('institute_name')

    if (storedInstitute) {
      setInstitutes([{ name: storedInstitute }]) // ✅ Wrap in an array
    }
  }, [])
  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
    ApiEndpoints.getAllClasses().then((res) => setClasses(res.data.data))
  }, [])
  useEffect(() => {
    ApiEndpoints.getAllInstitutes().then((res) => {
      if (Array.isArray(res.data.data)) {
        setInstitutes(res.data.data)
      } else {
        setInstitutes([]) // Fallback to empty array
      }
    })
  }, [])

  const [img, setImg] = useState(null)
  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        const response = await ApiEndpoints.viewProfile(id)
        console.log('Response of viewProfile: ', response.data.data)
        setData(response.data.data)
        setStudentData(response.data.data)
        setImg(response.data.data)
      } catch (error) {
        error(error.response?.data?.message || 'Something wents worng.')
      }
    }
    if (id) fetchStudentData()
  }, [id])

  // Fetch guardians for the student
  const fetchGuardians = async () => {
    if (!id) return
    setLoadingGuardians(true)
    try {
      const userCookie = Cookies.get("user")
      const user = JSON.parse(userCookie)
      let token = user.token

      // Try multiple endpoint patterns based on API structure
      const endpoints = [
        `/students/${id}/parents`,
        `/parents/student/${id}`,
        `/students/${id}/guardians`,
      ]

      let success = false
      for (const endpoint of endpoints) {
        try {
          const response = await axios.get(
            BASE_URL + endpoint,
            {
              headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`,
              },
            }
          )

          if (response.data && (response.data.status || response.data.data)) {
            const guardiansData = response.data.data || response.data
            if (Array.isArray(guardiansData)) {
              setGuardians(guardiansData)
            } else if (guardiansData && typeof guardiansData === 'object') {
              const dataArray = guardiansData.guardians || guardiansData.parents || guardiansData.data || []
              setGuardians(Array.isArray(dataArray) ? dataArray : [])
            } else {
              setGuardians([])
            }
            success = true
            break
          }
        } catch (endpointError) {
          continue
        }
      }

      if (!success) {
        setGuardians([])
      }
    } catch (error) {
      console.error('Error fetching guardians:', error)
      setGuardians([])
    } finally {
      setLoadingGuardians(false)
    }
  }

  useEffect(() => {
    if (id && data) {
      fetchGuardians()
    }
  }, [id, data])
  const calculateAge = (dob) => {
    if (!dob) return ''
    const birthDate = new Date(dob)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--
    }
    return age
  }

  const handleBack = () => {
    navigate('/student/discharged')
  }

  const handleSaveAsPDF = () => {
    if (!data) {
      toast.error('Student data not available')
      return
    }

    try {
      const doc = new jsPDF('p', 'mm', 'a4')
      const pageWidth = doc.internal.pageSize.getWidth()
      const pageHeight = doc.internal.pageSize.getHeight()
      const margin = 15
      let yPos = margin

      const checkPageBreak = (requiredHeight) => {
        if (yPos + requiredHeight > pageHeight - margin) {
          doc.addPage()
          yPos = margin
        }
      }

      // Title
      doc.setFontSize(20)
      doc.setFont('helvetica', 'bold')
      doc.setTextColor(37, 99, 235)
      doc.text('Student Information', pageWidth / 2, yPos, { align: 'center' })
      yPos += 10

      // Student Name
      doc.setFontSize(18)
      doc.setFont('helvetica', 'bold')
      doc.setTextColor(17, 24, 39)
      const studentName = data?.name
        ? data.name.charAt(0).toUpperCase() + data.name.slice(1).toLowerCase()
        : 'N/A'
      doc.text(studentName, pageWidth / 2, yPos, { align: 'center' })
      yPos += 8

      // Admission Number
      doc.setFontSize(12)
      doc.setFont('helvetica', 'normal')
      doc.setTextColor(107, 114, 128)
      doc.text(`Admission Number: ${data?.admission_number || 'N/A'}`, pageWidth / 2, yPos, { align: 'center' })
      yPos += 10

      // Divider line
      doc.setDrawColor(209, 213, 219)
      doc.line(margin, yPos, pageWidth - margin, yPos)
      yPos += 8

      // Section: Personal Information
      doc.setFontSize(14)
      doc.setFont('helvetica', 'bold')
      doc.setTextColor(37, 99, 235)
      doc.text('Personal Information', margin, yPos)
      yPos += 8

      doc.setFontSize(10)
      doc.setFont('helvetica', 'normal')
      doc.setTextColor(17, 24, 39)

      const admissionDetails = [
        `Admission Number: ${data?.admission_number || 'N/A'}`,
        `Admission Date: ${data?.admission_date || 'N/A'}`,
        `Institute Name: ${instituteName}`
      ]
      
      admissionDetails.forEach((detail) => {
        checkPageBreak(6)
        doc.text(detail, margin + 5, yPos)
        yPos += 6
      })
      yPos += 3

      checkPageBreak(20)
      doc.setFont('helvetica', 'bold')
      doc.text('Personal Details:', margin, yPos)
      yPos += 6
      doc.setFont('helvetica', 'normal')
      
      const personalDetails = [
        `Birth Date: ${data?.dob || 'N/A'}`,
        `Age: ${calculateAge(data?.dob) || 'N/A'} years`,
        `Gender: ${data?.gender || 'N/A'}`
      ]
      
      personalDetails.forEach((detail) => {
        checkPageBreak(6)
        doc.text(detail, margin + 5, yPos)
        yPos += 6
      })
      yPos += 3

      checkPageBreak(25)
      doc.setFont('helvetica', 'bold')
      doc.text('Contact Information:', margin, yPos)
      yPos += 6
      doc.setFont('helvetica', 'normal')
      
      const contactDetails = [
        `Email Address: ${data?.email || 'N/A'}`,
        `Phone Number: ${data?.phone || 'N/A'}`,
        `Parent's Number: ${data?.parents_number || 'N/A'}`,
        `WhatsApp Number: ${data?.whatsapp_number || 'N/A'}`,
        `Address: ${data?.address || 'N/A'}`
      ]
      
      contactDetails.forEach((detail) => {
        checkPageBreak(6)
        doc.text(detail, margin + 5, yPos)
        yPos += 6
      })
      yPos += 3

      checkPageBreak(10)
      doc.setFont('helvetica', 'bold')
      doc.text('Additional Information:', margin, yPos)
      yPos += 6
      doc.setFont('helvetica', 'normal')
      doc.text(`ID Proof Number: ${data?.id_proof_number || 'N/A'}`, margin + 5, yPos)
      yPos += 10

      // Section: Parent Information
      checkPageBreak(20)
      doc.setDrawColor(209, 213, 219)
      doc.line(margin, yPos, pageWidth - margin, yPos)
      yPos += 8

      doc.setFontSize(14)
      doc.setFont('helvetica', 'bold')
      doc.setTextColor(147, 51, 234)
      doc.text('Parent Information', margin, yPos)
      yPos += 8

      doc.setFontSize(10)
      doc.setFont('helvetica', 'normal')
      doc.setTextColor(17, 24, 39)
      
      const parentDetails = [
        `Father's Name: ${data?.father_name || 'N/A'}`,
        `Mother's Name: ${data?.mother_name || 'N/A'}`
      ]
      
      parentDetails.forEach((detail) => {
        checkPageBreak(6)
        doc.text(detail, margin + 5, yPos)
        yPos += 6
      })
      yPos += 10

      // Footer with date
      const totalPages = doc.internal.pages.length - 1
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i)
        doc.setFontSize(8)
        doc.setFont('helvetica', 'italic')
        doc.setTextColor(107, 114, 128)
        doc.text(
          `Generated on: ${new Date().toLocaleDateString()} | Page ${i} of ${totalPages}`,
          pageWidth / 2,
          pageHeight - 10,
          { align: 'center' }
        )
      }

      const fileName = `Discharged_Student_Profile_${data?.admission_number || data?.name || 'Student'}_${new Date().getTime()}.pdf`
      doc.save(fileName)
      toast.success('PDF generated successfully!')
    } catch (error) {
      console.error('Error generating PDF:', error)
      toast.error('Failed to generate PDF. Please try again.')
    }
  }

  const location = useLocation()
  
  const handleIdCard = () => {
    navigate(`/student/id-card/${id}`, { state: { fromLeftStudents: true } })
  }
  const handleUpdateStudentProfile = () => {
    // setHighlightUpdate(true)

    // setTimeout(() => setHighlightUpdate(false), 3000)
    navigate(`/student/update-profile/${id}`)
  }
  const handleViewFees = (id, course_id, class_id) => {
    // navigate(`/student/fees/${id}/${course_id}/${class_id}`)
    navigate(`/student/fees/${id}`,
      { 
        state: { fromDischargedList: true }
      })
    console.log('Student ID:', id)
    console.log('Course ID:', course_id)
    console.log('Class ID:', class_id)
  }

  // const handleAssignParent = async(id) =>{
  //   try {
  //     const userCookie = Cookies.get("user")
  //     const user = JSON.parse(userCookie)
  //     let token = user.token
  //     const response = await axios.post(BASE_URL+`/guardian/assign/student`,
  //     {
  //       email: selectedParent.email,
  //       student_id: id
  //     },
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`
  //       }
  //     }
  //     )
  //     toast.success(response.data.message)
  //   } catch (error) {
  //     toast.error(error.response?.data?.message)
  //   }
  // }


  const isValidEmail = (email)=>{
    return /\S+@\S+\.\S+/.test(email);
  }

  const handleAssignParent = async (id) => {
    if(!parentEmail){
      toast.error("Please enter an email")
      return
    }

    if(!isValidEmail(parentEmail)){
      toast.error("Please enter a valid email")
      return
    }
    try {
      const userCookie = Cookies.get("user")
      const user = JSON.parse(userCookie)
      let token = user.token

      const response = await axios.post(
        BASE_URL+"/guardian/assign/student",
        {
          email: parentEmail,
          student_id: id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )

      toast.success(response.data.message)
      setParentEmail("")
      fetchGuardians()
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong")
    }
  }

const handleViewParent = (id)=>{
  navigate(`/AddGuardian/${id.student_id}/${id.course_id}/${id.class_id}`)
    console.log('IDs:', id)
    console.log('Student ID:', id.student_id)
    console.log('Course ID:', id.course_id)
    console.log('Class ID:', id.class_id)
}

  const handleViewCourse = () => {
    const studentName = studentData?.name
    const admissionNumber = studentData?.admission_number

    navigate(`/student/enrolled-courses/${id}`, {
      state: {
        student_id: id,
        student_name: studentName,
        admission_number: admissionNumber,
      },
    })
    console.log('EnrolledCourses', id)
    console.log('studentName', studentName)
  }
  const handleViewAttendance = (id, course_id, class_id) => {
    if (!course_id || !class_id) {
      toast.error('Please add course and class first.')
      setHighlightUpdate(true)
      setTimeout(() => setHighlightUpdate(false), 5000)
    } else {
      navigate(`/student/discharged/attendance/${id}/${course_id}/${class_id}`)
      console.log('Student ID:', id)
      console.log('Course ID:', course_id)
      console.log('Class ID:', class_id)
    }
  }
  const handleDischarge = () => {
    setOpenDateModal(true)
    // navigate('/student/discharged')
  }
  // const handleViewResult = () => {
  // navigate(`/student/id-card/${id}`)
  // }

  const handleDischargeNow = async (e) => {
    e.preventDefault()
    if (!leavingDate) {
      toast.error('Please select a leaving date.')
      return
    }
    const userCookie = Cookies.get('user')
    if (!userCookie) {
      toast.error('User not authenticated. Please log in.')
      return
    }

    try {
      const status = 'inactive'

      const user = JSON.parse(userCookie)
      let token = user.token

      const response = await axios.post(
        BASE_URL+`/students/${id}/status?status=${status}&leaving_date=${leavingDate}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      )
      toast.success(response.data.message)
      navigate('/student/discharged')
    } catch (error) {
      console.error(error.response?.data?.message)
    }
  }

  const handleViewMarksheet = (id, course_id, class_id)=>{
    if (!course_id || !class_id) {
      toast.error('Please add course and class first.')
      setHighlightUpdate(true)
      setTimeout(() => setHighlightUpdate(false), 5000)
    } else {
      navigate(`/ExamMarksheet/${id}/${course_id}/${class_id}`)
      console.log('Student ID:', id)
      console.log('Course ID:', course_id)
      console.log('Class ID:', class_id)
    }
  }

  // Get course and class names
  const courseName = data?.course_id
    ? courses.find((course) => course.id === data.course_id)?.name || 'N/A'
    : 'N/A'
  const className = data?.class_id
    ? classes.find((cls) => cls.id === data.class_id)?.class_name || 'N/A'
    : 'N/A'
  const instituteName = data?.institute_id
    ? institutes?.find((insti) => insti.institute_id === data.institute_id)?.name || 'N/A'
    : 'N/A'

  return (
    <>
      <style>
        {`
          .info-label {
            font-size: 12px;
            font-weight: 600;
            color: #6b7280;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 6px;
            font-family: 'Inter', system-ui, sans-serif;
          }
          .info-value {
            font-size: 15px;
            font-weight: 500;
            color: #111827;
            font-family: 'Inter', system-ui, sans-serif;
          }
          .action-button {
            transition: all 0.2s ease;
          }
          .action-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          }
          .blink-updateButton {
            animation: blink 0.5s linear infinite;
            border: 2px solid #ff9900 !important;
          }
          @keyframes blink {
            50% {
              opacity: 0.5;
            }
          }
          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>

      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px',
        }}
      >
        {data ? (
          <>
            {/* Header */}
            <div
              className="container-fluid p-0"
              style={{
                marginTop: window.innerWidth < 992 ? '55px' : '-12px',
                paddingLeft: '0px',
                paddingRight: '0px',
              }}
            >
              <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
                <div 
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    background: '#F3F4F6',
                    paddingLeft: '28px',
                    paddingRight: '28px',
                    paddingTop: '12px',
                    paddingBottom: '12px',
                    overflow: 'visible',
                    borderBottom: '1px solid #D1D3D4',
                    width: '100%',
                  }}
                >
                  {/* Left: Title and Update Profile Icon Button */}
                  <div className="d-flex align-items-center gap-3">
                    {/* School Logo */}
                    <div style={{ 
                      width: '40px', 
                      height: '40px', 
                      borderRadius: '50%', 
                      overflow: 'hidden', 
                      background: '#223843',
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center', 
                      flexShrink: 0,
                    }}>
                      {!logoError ? (
                        <img 
                          src={logo} 
                          alt="School Logo" 
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          onError={() => setLogoError(true)}
                        />
                      ) : (
                        <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                      )}
                    </div>
                    
                    <h3 
                      className="m-0 fw-bold" 
                      style={{ 
                        letterSpacing: '-0.02em',
                        overflow: 'visible',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        fontSize: 'clamp(18px, 2.5vw, 22px)',
                        color: '#111827',
                        lineHeight: '1.2',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    >
                      {data?.name
                        ? data.name.charAt(0).toUpperCase() +
                          data.name.slice(1).toLowerCase()
                        : 'Student'} Profile
                    </h3>
                    <button
                      onClick={handleUpdateStudentProfile}
                      className={highlightUpdate ? 'blink-updateButton' : ''}
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#223843',
                        border: 'none',
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        flexShrink: 0,
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#223843'
                        e.currentTarget.style.transform = 'scale(1.05)'
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#223843'
                        e.currentTarget.style.transform = 'scale(1)'
                      }}
                      title="Update Profile"
                    >
                      <BsPencilFill size={20} />
                    </button>
                  </div>
                    
                  {/* Right: Profile Icon with Dropdown */}
                  {!isMobile && (
                    <ProfileDropdown logout={logout} />
                  )}
                </div>
              </div>
            </div>

            <Container 
              className="mt-4"
              style={{
                paddingLeft: isCollapsed ? '32px' : '40px',
                paddingRight: '32px',
                paddingTop: '32px',
                paddingBottom: '32px',
              }}
            >
              {/* Profile Summary Section - Two Column Layout */}
              <Row className="mb-4">
                {/* Profile Summary Card (Left) */}
                <Col xs={12} md={8}>
                  <Card 
                    style={{
                      border: '1px solid #D1D3D4',
                      borderRadius: '16px',
                      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                      height: '100%',
                    }}
                  >
                    <Card.Body style={{ padding: '40px', textAlign: 'center' }}>
                      {/* Profile Photo with Back Button */}
                      <div className="mb-4" style={{ position: 'relative', display: 'inline-block' }}>
                      {img?.student_image ? (
                          <div
                            style={{
                              width: '140px',
                              height: '140px',
                              borderRadius: '50%',
                              border: '4px solid #223843',
                              overflow: 'visible',
                              background: '#ffffff',
                              display: 'inline-block',
                              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                              position: 'relative',
                            }}
                          >
                        <img
                          src={img.student_image}
                          alt="Profile"
                          style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                borderRadius: '50%',
                              }}
                            />
                            {/* Back to List Button */}
                            <button
                              onClick={handleBack}
                              style={{
                                position: 'absolute',
                                bottom: '-8px',
                                right: '-8px',
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: '#223843',
                                border: '3px solid #ffffff',
                                color: '#ffffff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                                zIndex: 10,
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#223843'
                                e.currentTarget.style.transform = 'scale(1.1)'
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#223843'
                                e.currentTarget.style.transform = 'scale(1)'
                              }}
                              title="Back to Discharged Student list"
                            >
                              <FaArrowLeft size={16} />
                            </button>
                          </div>
                      ) : (
                        <div
                          style={{
                              width: '140px',
                              height: '140px',
                              borderRadius: '50%',
                              border: '4px solid #223843',
                              background: '#F3F4F6',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                              position: 'relative',
                            }}
                          >
                            <FaUser size={64} style={{ color: '#9ca3af' }} />
                            {/* Back to List Button */}
                            <button
                              onClick={handleBack}
                              style={{
                                position: 'absolute',
                                bottom: '-8px',
                                right: '-8px',
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: '#223843',
                                border: '3px solid #ffffff',
                                color: '#ffffff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                                zIndex: 10,
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#223843'
                                e.currentTarget.style.transform = 'scale(1.1)'
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#223843'
                                e.currentTarget.style.transform = 'scale(1)'
                              }}
                              title="Back to List"
                            >
                              <FaArrowLeft size={16} />
                            </button>
                        </div>
                      )}
                      </div>

                      {/* Student Name */}
                      <h2 className='text-uppercase'
                        style={{
                          color: '#111827',
                          fontWeight: '700',
                          fontSize: 'clamp(24px, 3vw, 32px)',
                          marginBottom: '12px',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        {data?.name
                          ? data.name.charAt(0).toUpperCase() +
                            data.name.slice(1).toLowerCase()
                          : 'N/A'}
                      </h2>

                      {/* Email/Admission Number */}
                      <div className="mb-4">
                        <p 
                         style={{
                            color: '#6b7280',
                            fontSize: '16px',
                            marginBottom: '8px',
                            fontFamily: 'Inter, system-ui, sans-serif',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                          }}
                        >
                          <FaEnvelope size={16} />
                          {data?.email || data?.admission_number || 'N/A'}
                        </p>
                      </div>

                      {/* Badges */}
                      <div className="d-flex flex-wrap justify-content-center gap-2">
                        <span
                          style={{
                            backgroundColor: '#EFF6FF',
                            color: '#223843',
                            padding: '8px 16px',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: '600',
                            fontFamily: 'Inter, system-ui, sans-serif',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                          }}
                        >
                          <BsPersonBadge />
                          {data?.admission_number || 'N/A'}
                        </span>
                        <span
                          style={{
                            backgroundColor: data?.status === 'active' ? '#ECFDF5' : '#FEE2E2',
                            color: data?.status === 'active' ? '#10B981' : '#EF4444',
                            padding: '8px 16px',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: '600',
                            fontFamily: 'Inter, system-ui, sans-serif',
                          }}
                        >
                          {data?.status
                            ? data.status.charAt(0).toUpperCase() +
                              data.status.slice(1)
                            : 'N/A'}
                        </span>
                        {courseName !== 'N/A' && (
                          <span
                            style={{
                              backgroundColor: '#EFF6FF',
                              color: '#223843',
                              padding: '8px 16px',
                              borderRadius: '20px',
                              fontSize: '13px',
                              fontWeight: '600',
                              fontFamily: 'Inter, system-ui, sans-serif',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px',
                            }}
                          >
                            <FaGraduationCap />
                            {courseName}
                          </span>
                        )}
                        {className !== 'N/A' && (
                          <span
                            style={{
                              backgroundColor: '#EFF6FF',
                              color: '#223843',
                              padding: '8px 16px',
                              borderRadius: '20px',
                              fontSize: '13px',
                              fontWeight: '600',
                              fontFamily: 'Inter, system-ui, sans-serif',
                            }}
                          >
                            {className}
                          </span>
                        )}
                        {data?.gender && (
                          <span
                            style={{
                              backgroundColor: '#F3F4F6',
                              color: '#111827',
                              padding: '8px 16px',
                              borderRadius: '20px',
                              fontSize: '13px',
                              fontWeight: '600',
                              fontFamily: 'Inter, system-ui, sans-serif',
                            }}
                          >
                            {data.gender}
                          </span>
                        )}
                      </div>

                      {/* Save as PDF Button */}
                      <div className="mt-4 d-flex justify-content-center">
                        <button
                          onClick={handleSaveAsPDF}
                          style={{
                            backgroundColor: '#10B981',
                            border: 'none',
                            color: '#ffffff',
                            borderRadius: '12px',
                            padding: '12px 24px',
                            fontWeight: '600',
                            fontSize: '14px',
                            fontFamily: 'Inter, system-ui, sans-serif',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 4px rgba(16, 185, 129, 0.2)',
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#059669'
                            e.currentTarget.style.transform = 'translateY(-2px)'
                            e.currentTarget.style.boxShadow = '0 4px 8px rgba(16, 185, 129, 0.3)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#10B981'
                            e.currentTarget.style.transform = 'translateY(0)'
                            e.currentTarget.style.boxShadow = '0 2px 4px rgba(16, 185, 129, 0.2)'
                          }}
                        >
                          <BsFileEarmarkPdfFill size={18} /> Save as PDF
                        </button>
                      </div>
                    </Card.Body>
                  </Card>
                    </Col>

                {/* Side Highlight Card (Right) */}
                <Col xs={12} md={4}>
                  <Card 
                    style={{
                      border: '1px solid #D1D3D4',
                      borderRadius: '16px',
                      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                      background: 'linear-gradient(135deg, #F3F4F6 0%, #ffffff 100%)',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginTop: isMobile ? '16px' : undefined,
                    }}
                  >
                    <Card.Body style={{ 
                      padding: '40px', 
                      textAlign: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '100%',
                    }}>
                      <div style={{ width: '100%' }}>
                        <div
                          style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '50%',
                            backgroundColor: '#EFF6FF',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '20px',
                          }}
                        >
                          <BsPrinterFill size={40} style={{ color: '#223843' }} />
                        </div>
                        <h5
                          style={{
                            color: '#111827',
                            fontWeight: '600',
                            fontSize: '18px',
                            marginBottom: '12px',
                            fontFamily: 'Inter, system-ui, sans-serif',
                          }}
                        >
                        Print ID Card
                        </h5>
                        <p
                          style={{
                            color: '#6b7280',
                            fontSize: '14px',
                            marginBottom: '24px',
                            fontFamily: 'Inter, system-ui, sans-serif',
                          }}
                        >
                          Generate and print student identification card
                        </p>
                        <Button
                          onClick={handleIdCard}
                          className="w-100 action-button"
                          style={{
                            backgroundColor: '#223843',
                            border: 'none',
                            color: '#ffffff',
                            borderRadius: '12px',
                            padding: '14px 28px',
                            fontWeight: '600',
                            fontSize: '16px',
                            fontFamily: 'Inter, system-ui, sans-serif',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#223843'
                            e.currentTarget.style.transform = 'translateY(-2px)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#223843'
                            e.currentTarget.style.transform = 'translateY(0)'
                          }}
                        >
                          <BsPrinterFill /> Print ID Card
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                    </Col>
                  </Row>

              {/* Personal Information Section */}
              <Row className="mb-4">
                <Col xs={12}>
                  <Card
                    style={{
                      border: '1px solid #D1D3D4',
                      borderRadius: '16px',
                      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                      overflow: 'hidden',
                    }}
                  >
                    {/* Header with Icon */}
                    <div
                      style={{
                        background: 'linear-gradient(135deg, #223843 0%, #223843 100%)',
                        padding: '16px 24px',
                        borderBottom: '1px solid #D1D3D4',
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          <div
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '10px',
                              backgroundColor: 'rgba(255, 255, 255, 0.2)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backdropFilter: 'blur(10px)',
                            }}
                          >
                            <FaUser size={18} style={{ color: '#ffffff' }} />
                          </div>
                          <div>
                            <h5 className='text-start'
                              style={{
                                margin: 0,
                                fontWeight: '700',
                                color: '#ffffff',
                                fontSize: '18px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Personal Information
                            </h5>
                            <p
                              style={{
                                margin: '2px 0 0 0',
                                color: 'rgba(255, 255, 255, 0.9)',
                                fontSize: '12px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Student details and contact information
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={() => setShowPersonalInfo(!showPersonalInfo)}
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                            border: 'none',
                            color: '#ffffff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            flexShrink: 0,
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'
                            e.currentTarget.style.transform = 'scale(1.1)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'
                            e.currentTarget.style.transform = 'scale(1)'
                          }}
                          title={showPersonalInfo ? "Hide Section" : "Show Section"}
                        >
                          {showPersonalInfo ? <BsChevronUp size={18} /> : <BsChevronDown size={18} />}
                        </button>
                      </div>
                    </div>

                    {showPersonalInfo && (
                      <Card.Body style={{ padding: '20px' }}>
                        <Row className="g-3 text-start">
                          {/* Left Column */}
                        <Col xs={12} md={6}>
                          {/* Admission Details Card */}
                          <div
                            style={{
                              backgroundColor: '#F9FAFB',
                              borderRadius: '12px',
                              padding: '14px',
                              border: '1px solid #E5E7EB',
                              marginBottom: '12px',
                            }}
                          >
                            <h6
                              style={{
                                marginBottom: '10px',
                                fontWeight: '600',
                                color: '#223843',
                                fontSize: '12px',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Admission Details
                            </h6>
                            <div className="d-flex flex-column gap-2">
                              <div
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  border: '1px solid #E5E7EB',
                                }}
                              >
                                <div className="d-flex align-items-center gap-2 mb-1">
                                  <BsPersonBadge size={14} style={{ color: '#223843' }} />
                                  <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Admission Number</div>
                                </div>
                                <div className="info-value" style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                          {data?.admission_number || 'N/A'}
                      </div>
                      </div>

                              <div
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  border: '1px solid #E5E7EB',
                                }}
                              >
                                <div className="d-flex align-items-center gap-2 mb-1">
                                  <BsCalendar3 size={14} style={{ color: '#223843' }} />
                                  <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Admission Date</div>
                      </div>
                                <div className="info-value" style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                                  {data?.admission_date || 'N/A'}
                      </div>
                      </div>

                              <div
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  border: '1px solid #E5E7EB',
                                }}
                              >
                                <div className="d-flex align-items-center gap-2 mb-1">
                                  <BsBuilding size={14} style={{ color: '#223843' }} />
                                  <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Institute Name</div>
                      </div>
                                <div className="info-value" style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                                  {instituteName}
                      </div>
                      </div>
                            </div>
                          </div>

                          {/* Personal Details Card */}
                          <div
                            style={{
                              backgroundColor: '#F9FAFB',
                              borderRadius: '12px',
                              padding: '14px',
                              border: '1px solid #E5E7EB',
                            }}
                          >
                            <h6
                              style={{
                                marginBottom: '10px',
                                fontWeight: '600',
                                color: '#10B981',
                                fontSize: '12px',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Personal Details
                            </h6>
                            <div className="d-flex flex-column gap-2">
                              <div
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  border: '1px solid #E5E7EB',
                                }}
                              >
                                <div className="d-flex align-items-center gap-2 mb-1">
                                  <BsCalendar3 size={14} style={{ color: '#10B981' }} />
                                  <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Birth Date</div>
                      </div>
                                <div className="info-value" style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                                  {data?.dob || 'N/A'}
                      </div>
                              </div>

                              <div
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  border: '1px solid #E5E7EB',
                                }}
                              >
                                <div className="d-flex align-items-center gap-2 mb-1">
                                  <FaUser size={14} style={{ color: '#10B981' }} />
                                  <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Age</div>
                      </div>
                                <div className="info-value" style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                                  {calculateAge(data?.dob) || 'N/A'} years
                                </div>
                              </div>

                              <div
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  border: '1px solid #E5E7EB',
                                }}
                              >
                                <div className="d-flex align-items-center gap-2 mb-1">
                                  <FaVenusMars size={14} style={{ color: '#10B981' }} />
                                  <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Gender</div>
                                </div>
                                <div className="info-value" style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                                  {data?.gender || 'N/A'}
                                </div>
                              </div>
                            </div>
                      </div>
                    </Col>

                        {/* Right Column */}
                        <Col xs={12} md={6}>
                          {/* Contact Information Card */}
                          <div
                            style={{
                              backgroundColor: '#F9FAFB',
                              borderRadius: '12px',
                              padding: '14px',
                              border: '1px solid #E5E7EB',
                              marginBottom: '12px',
                            }}
                          >
                            <h6
                              style={{
                                marginBottom: '10px',
                                fontWeight: '600',
                                color: '#F59E0B',
                                fontSize: '12px',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Contact Information
                            </h6>
                            <div className="d-flex flex-column gap-2">
                              <div
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  border: '1px solid #E5E7EB',
                                }}
                              >
                                <div className="d-flex align-items-center gap-2 mb-1">
                                  <FaEnvelope size={14} style={{ color: '#F59E0B' }} />
                                  <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Email Address</div>
                                </div>
                                <div className="info-value" style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                                  {data?.email || 'N/A'}
                                </div>
                              </div>

                              <div
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  border: '1px solid #E5E7EB',
                                }}
                              >
                                <div className="d-flex align-items-center gap-2 mb-1">
                                  <FaPhone size={14} style={{ color: '#F59E0B' }} />
                                  <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Phone Number</div>
                                </div>
                                <div className="info-value" style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                                  {data?.phone || 'N/A'}
                                </div>
                              </div>

                              <div
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  border: '1px solid #E5E7EB',
                                }}
                              >
                                <div className="d-flex align-items-center gap-2 mb-1">
                                  <FaPhone size={14} style={{ color: '#F59E0B' }} />
                                  <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Parent's Number</div>
                                </div>
                                <div className="info-value" style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                                  {data?.parents_number || 'N/A'}
                                </div>
                              </div>

                              <div
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  border: '1px solid #E5E7EB',
                                }}
                              >
                                <div className="d-flex align-items-center gap-2 mb-1">
                                  <FaWhatsapp size={14} style={{ color: '#F59E0B' }} />
                                  <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>WhatsApp Number</div>
                                </div>
                                <div className="info-value" style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                                  {data?.whatsapp_number || 'N/A'}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Additional Information Card */}
                          <div
                            style={{
                              backgroundColor: '#F9FAFB',
                              borderRadius: '12px',
                              padding: '14px',
                              border: '1px solid #E5E7EB',
                            }}
                          >
                            <h6
                              style={{
                                marginBottom: '10px',
                                fontWeight: '600',
                                color: '#223843',
                                fontSize: '12px',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Additional Information
                            </h6>
                            <div className="d-flex flex-column gap-2">
                              <div
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  border: '1px solid #E5E7EB',
                                }}
                              >
                                <div className="d-flex align-items-center gap-2 mb-1">
                                  <FaMapMarkerAlt size={14} style={{ color: '#10B981' }} />
                                  <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Address</div>
                                </div>
                                <div className="info-value" style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                                  {data?.address || 'N/A'}
                                </div>
                              </div>

                              <div
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  border: '1px solid #E5E7EB',
                                }}
                              >
                                <div className="d-flex align-items-center gap-2 mb-1">
                                  <BsFileEarmarkText size={14} style={{ color: '#223843' }} />
                                  <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>ID Proof Number</div>
                                </div>
                                <div className="info-value" style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                                  {data?.id_proof_number || 'N/A'}
                                </div>
                              </div>
                            </div>
                      </div>
                    </Col>
                      </Row>
                    </Card.Body>
                    )}
                  </Card>
                </Col>
              </Row>

              {/* Parent Information Section */}
              <Row className="mb-4">
                <Col xs={12}>
                  <Card
                    style={{
                      border: '1px solid #D1D3D4',
                      borderRadius: '16px',
                      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                      overflow: 'hidden',
                    }}
                  >
                    {/* Header with Icon */}
                    <div
                      style={{
                        background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
                        padding: '16px 24px',
                        borderBottom: '1px solid #D1D3D4',
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          <div
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '10px',
                              backgroundColor: 'rgba(255, 255, 255, 0.2)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backdropFilter: 'blur(10px)',
                            }}
                          >
                            <FaUsers size={18} style={{ color: '#ffffff' }} />
                          </div>
                          <div>
                            <h5
                              style={{
                                margin: 0,
                                fontWeight: '700',
                                color: '#ffffff',
                                fontSize: '18px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Parent Information
                            </h5>
                            <p className='text-start'
                              style={{
                                margin: '2px 0 0 0',
                                color: 'rgba(255, 255, 255, 0.9)',
                                fontSize: '12px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Guardian and parent details
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={() => setShowParentInfo(!showParentInfo)}
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                            border: 'none',
                            color: '#ffffff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            flexShrink: 0,
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'
                            e.currentTarget.style.transform = 'scale(1.1)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'
                            e.currentTarget.style.transform = 'scale(1)'
                          }}
                          title={showParentInfo ? "Hide Section" : "Show Section"}
                        >
                          {showParentInfo ? <BsChevronUp size={18} /> : <BsChevronDown size={18} />}
                        </button>
                      </div>
                    </div>

                    {showParentInfo && (
                      <Card.Body style={{ padding: '20px' }}>
                      <Row className="g-3 text-start">
                        <Col xs={12} md={6}>
                          <div
                            style={{
                              backgroundColor: '#F9FAFB',
                              borderRadius: '12px',
                              padding: '14px',
                              border: '1px solid #E5E7EB',
                              height: '100%',
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: '#ffffff',
                                borderRadius: '8px',
                                padding: '12px',
                                border: '1px solid #E5E7EB',
                              }}
                            >
                              <div className="d-flex align-items-center gap-2 mb-1">
                                <div
                                  style={{
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '8px',
                                    backgroundColor: '#F3E8FF',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <FaUsers size={16} style={{ color: '#9333EA' }} />
                                </div>
                                <div style={{ flex: 1 }}>
                                  <div className="info-label" style={{ marginBottom: '2px', fontSize: '11px' }}>Father's Name</div>
                                  <div className="info-value" style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>
                                    {data?.father_name || 'N/A'}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} md={6}>
                          <div
                            style={{
                              backgroundColor: '#F9FAFB',
                              borderRadius: '12px',
                              padding: '14px',
                              border: '1px solid #E5E7EB',
                              height: '100%',
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: '#ffffff',
                                borderRadius: '8px',
                                padding: '12px',
                                border: '1px solid #E5E7EB',
                              }}
                            >
                              <div className="d-flex align-items-center gap-2 mb-1">
                                <div
                                  style={{
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '8px',
                                    backgroundColor: '#F3E8FF',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <FaUsers size={16} style={{ color: '#9333EA' }} />
                                </div>
                                <div style={{ flex: 1 }}>
                                  <div className="info-label" style={{ marginBottom: '2px', fontSize: '11px' }}>Mother's Name</div>
                                  <div className="info-value" style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>
                                    {data?.mother_name || 'N/A'}
                                  </div>
                                </div>
                              </div>
                            </div>
                      </div>
                        </Col>
                      </Row>
                    </Card.Body>
                    )}
                  </Card>
                    </Col>
                  </Row>

              {/* Assign Guardian Section */}
              {/* <Row className="mb-4">
                <Col xs={12}>
                  <Card
                    style={{
                      border: '1px solid #D1D3D4',
                      borderRadius: '16px',
                      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        background: 'linear-gradient(135deg, #223843 0%, #223843 100%)',
                        padding: '16px 24px',
                        borderBottom: '1px solid #D1D3D4',
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          <div
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '10px',
                              backgroundColor: 'rgba(255, 255, 255, 0.2)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backdropFilter: 'blur(10px)',
                            }}
                          >
                            <FaShieldAlt size={18} style={{ color: '#ffffff' }} />
                          </div>
                          <div>
                            <h5 className='text-start'
                              style={{
                                margin: 0,
                                fontWeight: '700',
                                color: '#ffffff',
                                fontSize: '18px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Assign Guardian
                            </h5>
                            <p
                              style={{
                                margin: '2px 0 0 0',
                                color: 'rgba(255, 255, 255, 0.9)',
                                fontSize: '12px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Assign and manage guardian for this student
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={() => setShowAssignGuardian(!showAssignGuardian)}
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                            border: 'none',
                            color: '#ffffff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            flexShrink: 0,
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'
                            e.currentTarget.style.transform = 'scale(1.1)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'
                            e.currentTarget.style.transform = 'scale(1)'
                          }}
                          title={showAssignGuardian ? "Hide Section" : "Show Section"}
                        >
                          {showAssignGuardian ? <BsChevronUp size={18} /> : <BsChevronDown size={18} />}
                        </button>
                      </div>
                    </div>

                    {showAssignGuardian && (
                      <Card.Body style={{ padding: '20px' }}>
                      <Row className="g-3 align-items-end">
                        <Col xs={12} md={5} className="text-start">
                        <FormGroup>
                            <FormLabel 
                              style={{ 
                                fontSize: '12px', 
                                fontWeight: '600', 
                                color: '#6b7280', 
                                fontFamily: 'Inter, system-ui, sans-serif',
                                marginBottom: '8px',
                              }}
                            >
                              Guardian Email
                            </FormLabel>
                          <Form.Control
                            type="email"
                            placeholder="Enter Guardian Email"
                            value={parentEmail}
                            onChange={(e) => setParentEmail(e.target.value)} 
                              style={{
                                borderRadius: '8px',
                                border: '1px solid #D1D3D4',
                                padding: '10px 14px',
                                fontSize: '14px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                                transition: 'all 0.2s ease',
                              }}
                              onFocus={(e) => {
                                e.target.style.borderColor = '#223843'
                                e.target.style.boxShadow = '0 0 0 3px rgba(37, 99, 235, 0.1)'
                              }}
                              onBlur={(e) => {
                                e.target.style.borderColor = '#D1D3D4'
                                e.target.style.boxShadow = 'none'
                              }}
                          />
                        </FormGroup>
                    </Col>
                        <Col xs={6} md={3}>
                      <div
                            className="d-flex align-items-center gap-2"
                            style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                            onMouseEnter={(e) => {
                              const button = e.currentTarget.querySelector('button')
                              const text = e.currentTarget.querySelector('span')
                              if (button) {
                                button.style.backgroundColor = '#223843'
                                button.style.borderColor = '#223843'
                                button.style.transform = 'scale(1.05)'
                              }
                              if (text) {
                                text.style.transform = 'scale(1.05)'
                              }
                              e.currentTarget.style.transform = 'scale(1.02)'
                            }}
                            onMouseLeave={(e) => {
                              const button = e.currentTarget.querySelector('button')
                              const text = e.currentTarget.querySelector('span')
                              if (button) {
                                button.style.backgroundColor = '#223843'
                                button.style.borderColor = '#223843'
                                button.style.transform = 'scale(1)'
                              }
                              if (text) {
                                text.style.transform = 'scale(1)'
                              }
                              e.currentTarget.style.transform = 'scale(1)'
                            }}
                          >
                            <button
                              onClick={() => handleAssignParent(data.id)}
                              style={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '50%',
                                border: '1px solid #223843',
                                backgroundColor: '#223843',
                                color: '#ffffff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                flexShrink: 0,
                              }}
                              title="Assign Guardian"
                            >
                              <FaShieldAlt size={20} />
                            </button>
                              <span style={{ 
                                fontSize: '14px', 
                                color: '#111827', 
                                fontFamily: 'Inter, system-ui, sans-serif', 
                                fontWeight: '500',
                                transition: 'transform 0.2s ease',
                                display: 'inline-block',
                              }}>
                                Assign Guardian
                              </span>
                          </div>
                    </Col>
                        <Col xs={6} md={4}>
                      <div
                            className="d-flex align-items-center gap-2"
                            style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                            onMouseEnter={(e) => {
                              const button = e.currentTarget.querySelector('button')
                              const text = e.currentTarget.querySelector('span')
                              if (button) {
                                button.style.backgroundColor = '#223843'
                                button.style.borderColor = '#223843'
                                button.style.color = '#ffffff'
                                button.style.transform = 'scale(1.05)'
                              }
                              if (text) {
                                text.style.transform = 'scale(1.05)'
                              }
                              e.currentTarget.style.transform = 'scale(1.02)'
                            }}
                            onMouseLeave={(e) => {
                              const button = e.currentTarget.querySelector('button')
                              const text = e.currentTarget.querySelector('span')
                              if (button) {
                                button.style.backgroundColor = '#ffffff'
                                button.style.borderColor = '#D1D3D4'
                                button.style.color = '#111827'
                                button.style.transform = 'scale(1)'
                              }
                              if (text) {
                                text.style.transform = 'scale(1)'
                              }
                              e.currentTarget.style.transform = 'scale(1)'
                            }}
                          >
                            <button
                              onClick={() => navigate(`/AddGuardian`)}
                              style={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '50%',
                                border: '1px solid #D1D3D4',
                                backgroundColor: '#ffffff',
                                color: '#111827',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                flexShrink: 0,
                              }}
                              title="View All Guardians"
                            >
                              <FaEye size={20} />
                            </button>
                              <span className='d-flex text-start' style={{ 
                                fontSize: '14px', 
                                color: '#111827', 
                                fontFamily: 'Inter, system-ui, sans-serif', 
                                fontWeight: '500',
                                transition: 'transform 0.2s ease',
                                display: 'inline-block',
                              }}>
                                View All Guardians
                              </span>
                          </div>
                    </Col>
                  </Row>

                      <div style={{ marginTop: '24px', paddingTop: '24px', borderTop: '1px solid #E5E7EB' }}>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <div className="d-flex align-items-center gap-2">
                            <div
                              style={{
                                width: '32px',
                                height: '32px',
                                borderRadius: '8px',
                                backgroundColor: '#DBEAFE',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <FaUsers size={16} style={{ color: '#223843' }} />
                            </div>
                            <h6
                              style={{
                                margin: 0,
                                fontWeight: '600',
                                color: '#111827',
                                fontSize: '14px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Assigned Guardians ({guardians.length})
                            </h6>
                          </div>
                          <button
                            onClick={fetchGuardians}
                            disabled={loadingGuardians}
                            style={{
                              width: '48px',
                              height: '48px',
                              borderRadius: '50%',
                              backgroundColor: '#223843',
                              border: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: loadingGuardians ? 'not-allowed' : 'pointer',
                              transition: 'all 0.2s ease',
                              opacity: loadingGuardians ? 0.7 : 1,
                            }}
                            onMouseEnter={(e) => {
                              if (!loadingGuardians) {
                                e.currentTarget.style.backgroundColor = '#223843'
                                e.currentTarget.style.transform = 'scale(1.05)'
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!loadingGuardians) {
                                e.currentTarget.style.backgroundColor = '#223843'
                                e.currentTarget.style.transform = 'scale(1)'
                              }
                            }}
                            title="Refresh Guardians List"
                          >
                            <BsArrowClockwise 
                              size={20} 
                              style={{ 
                                animation: loadingGuardians ? 'spin 1s linear infinite' : 'none',
                              }} 
                            />
                          </button>
                        </div>

                        {loadingGuardians ? (
                          <div 
                            className="text-center py-4"
                            style={{
                              backgroundColor: '#F9FAFB',
                              borderRadius: '8px',
                              padding: '32px',
                              border: '1px solid #E5E7EB',
                            }}
                          >
                            <BsArrowClockwise 
                              size={24} 
                              style={{ 
                                color: '#223843',
                                animation: 'spin 1s linear infinite',
                                marginBottom: '12px',
                              }} 
                            />
                            <p style={{ color: '#6b7280', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif', margin: 0 }}>
                              Loading guardians...
                            </p>
                          </div>
                        ) : guardians.length > 0 ? (
                          <Row className="g-3">
                            {guardians.map((guardian, index) => (
                              <Col xs={12} md={6} key={index}>
                                <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '12px 16px',
                                    border: '1px solid #E5E7EB',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    transition: 'all 0.2s ease',
                                    height: '100%',
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#F9FAFB'
                                    e.currentTarget.style.borderColor = '#223843'
                                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(37, 99, 235, 0.1)'
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = '#ffffff'
                                    e.currentTarget.style.borderColor = '#E5E7EB'
                                    e.currentTarget.style.boxShadow = 'none'
                                  }}
                                >
                                  <div
                                    style={{
                                      width: '40px',
                                      height: '40px',
                                      borderRadius: '10px',
                                      backgroundColor: '#DBEAFE',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      flexShrink: 0,
                                    }}
                                  >
                                    <FaUsers size={18} style={{ color: '#223843' }} />
                                  </div>
                                  <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0 }}>
                                    <div
                                      style={{
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#111827',
                                        fontFamily: 'Inter, system-ui, sans-serif',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        flexShrink: 0,
                                      }}
                                    >
                                      {guardian.name || guardian.parent_name || guardian.guardian_name || 'Guardian'}
                                    </div>
                                    {guardian.email && (
                                      <div className="d-flex align-items-center gap-2" style={{ flexShrink: 0, marginLeft: 'auto' }}>
                                        <FaEnvelope size={14} style={{ color: '#6b7280', flexShrink: 0 }} />
                                        <span style={{ 
                                          fontSize: '13px', 
                                          color: '#6b7280', 
                                          fontFamily: 'Inter, system-ui, sans-serif',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          maxWidth: '200px',
                                        }}>
                                          {guardian.email}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Col>
                            ))}
                          </Row>
                        ) : (
                          <div
                            style={{
                              backgroundColor: '#F9FAFB',
                              borderRadius: '8px',
                              padding: '32px',
                              textAlign: 'center',
                              border: '1px dashed #D1D3D4',
                            }}
                          >
                            <div
                              style={{
                                width: '64px',
                                height: '64px',
                                borderRadius: '50%',
                                backgroundColor: '#E5E7EB',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '16px',
                              }}
                            >
                              <FaUsers size={28} style={{ color: '#9ca3af' }} />
                            </div>
                            <p
                              style={{
                                margin: 0,
                                color: '#111827',
                                fontSize: '15px',
                                fontWeight: '600',
                                fontFamily: 'Inter, system-ui, sans-serif',
                                marginBottom: '4px',
                              }}
                            >
                              No guardians assigned yet
                            </p>
                            <p
                              style={{
                                margin: 0,
                                color: '#6b7280',
                                fontSize: '13px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Assign a guardian using the form above
                            </p>
                          </div>
                        )}
                      </div>
                    </Card.Body>
                    )}
                  </Card>
                </Col>
              </Row> */}

              {/* Student Actions Section */}
              <Row>
                <Col xs={12}>
                  <Card
                    style={{
                      border: '1px solid #D1D3D4',
                      borderRadius: '16px',
                      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                      overflow: 'hidden',
                    }}
                  >
                    {/* Header with Icon */}
                    <div
                      style={{
                        background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                        padding: '16px 24px',
                        borderBottom: '1px solid #D1D3D4',
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          <div
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '10px',
                              backgroundColor: 'rgba(255, 255, 255, 0.2)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backdropFilter: 'blur(10px)',
                            }}
                          >
                            <FaGraduationCap size={18} style={{ color: '#ffffff' }} />
                          </div>
                          <div>
                            <h5 className='text-start'
                              style={{
                                margin: 0,
                                fontWeight: '700',
                                color: '#ffffff',
                                fontSize: '18px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Student Actions
                            </h5>
                            <p
                              style={{
                                margin: '2px 0 0 0',
                                color: 'rgba(255, 255, 255, 0.9)',
                                fontSize: '12px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Quick access to student management features
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={() => setShowStudentActions(!showStudentActions)}
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                            border: 'none',
                            color: '#ffffff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            flexShrink: 0,
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'
                            e.currentTarget.style.transform = 'scale(1.1)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'
                            e.currentTarget.style.transform = 'scale(1)'
                          }}
                          title={showStudentActions ? "Hide Section" : "Show Section"}
                        >
                          {showStudentActions ? <BsChevronUp size={18} /> : <BsChevronDown size={18} />}
                        </button>
                      </div>
                    </div>

                    {showStudentActions && (
                      <Card.Body style={{ padding: '20px' }}>
                      <Row className="g-3">
                        <Col xs={6} sm={4} md={2.4}>
                      <Button
                            variant="light"
                            onClick={() => handleViewFees(data.id, data.course_id, data.class_id)}
                            className="w-100 action-button"
                            style={{
                              backgroundColor: '#EFF6FF',
                              border: '1px solid #DBEAFE',
                              color: '#223843',
                              borderRadius: '10px',
                              padding: '16px 12px',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              gap: '8px',
                              fontFamily: 'Inter, system-ui, sans-serif',
                              fontWeight: '600',
                              transition: 'all 0.2s ease',
                              minHeight: '100px',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#DBEAFE'
                              e.currentTarget.style.transform = 'translateY(-3px)'
                              e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.2)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#EFF6FF'
                              e.currentTarget.style.transform = 'translateY(0)'
                              e.currentTarget.style.boxShadow = 'none'
                            }}
                          >
                            <div
                              style={{
                                width: '44px',
                                height: '44px',
                                borderRadius: '12px',
                                backgroundColor: '#223843',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '4px',
                              }}
                            >
                              <FaWallet size={20} style={{ color: '#ffffff' }} />
                            </div>
                            <span style={{ fontSize: '13px', fontWeight: '600' }}>Fees</span>
                      </Button>
                    </Col>
                        <Col xs={6} sm={4} md={2.4}>
                      <Button
                            variant="light"
                        onClick={handleViewCourse}
                            className="w-100 action-button"
                            style={{
                              backgroundColor: '#ECFDF5',
                              border: '1px solid #D1FAE5',
                              color: '#10B981',
                              borderRadius: '10px',
                              padding: '16px 12px',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              gap: '8px',
                              fontFamily: 'Inter, system-ui, sans-serif',
                              fontWeight: '600',
                              transition: 'all 0.2s ease',
                              minHeight: '100px',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#D1FAE5'
                              e.currentTarget.style.transform = 'translateY(-3px)'
                              e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.2)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#ECFDF5'
                              e.currentTarget.style.transform = 'translateY(0)'
                              e.currentTarget.style.boxShadow = 'none'
                            }}
                          >
                            <div
                              style={{
                                width: '44px',
                                height: '44px',
                                borderRadius: '12px',
                                backgroundColor: '#10B981',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '4px',
                              }}
                            >
                              <FaGraduationCap size={20} style={{ color: '#ffffff' }} />
                            </div>
                            <span style={{ fontSize: '13px', fontWeight: '600' }}>Courses</span>
                      </Button>
                    </Col>
                        <Col xs={6} sm={4} md={2.4}>
                      <Button
                            variant="light"
                            onClick={() => handleViewAttendance(data.id, data.course_id, data.class_id)}
                            className="w-100 action-button"
                            style={{
                              backgroundColor: '#FEF3C7',
                              border: '1px solid #FDE68A',
                              color: '#F59E0B',
                              borderRadius: '10px',
                              padding: '16px 12px',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              gap: '8px',
                              fontFamily: 'Inter, system-ui, sans-serif',
                              fontWeight: '600',
                              transition: 'all 0.2s ease',
                              minHeight: '100px',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#FDE68A'
                              e.currentTarget.style.transform = 'translateY(-3px)'
                              e.currentTarget.style.boxShadow = '0 4px 12px rgba(245, 158, 11, 0.2)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#FEF3C7'
                              e.currentTarget.style.transform = 'translateY(0)'
                              e.currentTarget.style.boxShadow = 'none'
                            }}
                          >
                            <div
                              style={{
                                width: '44px',
                                height: '44px',
                                borderRadius: '12px',
                                backgroundColor: '#F59E0B',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '4px',
                              }}
                            >
                              <FaCalendarCheck size={20} style={{ color: '#ffffff' }} />
                            </div>
                            <span style={{ fontSize: '13px', fontWeight: '600' }}>Attendance</span>
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
                )}
              </Card>
                </Col>
              </Row>
            </Container>
          </>
        ) : (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
            <p style={{ color: '#6b7280', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
              Loading student data...
            </p>
          </div>
        )}
      </div>
      <Modal
        centered
        show={opentDateModal}
        onHide={() => setOpenDateModal(false)}
      >
        <Modal.Header closeButton 
        closeVariant="white"
        className="bg-danger text-white">
          <Modal.Title>Select Leaving Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Select Date</Form.Label>
              <Form.Control
                type="date"
                name="leaving_date"
                value={leavingDate}
                onChange={(e) => setLeavingDate(e.target.value)}
              />
            </Form.Group>
          </Form>
          <Modal.Footer>
            <Button
              variant="outline-secondary"
              onClick={() => setOpenDateModal(false)}
            >
              Close
            </Button>
            <Button variant="outline-danger" onClick={handleDischargeNow}>
              Leave Now
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default DischargedStudentsProfile
